<script lang="ts">
  import { onMount } from 'svelte';
  import type { ApiClient } from '../lib/api';
  import Loading from '../lib/Loading.svelte';
  import type { Router } from '../lib/router.svelte';
  import type { Customer } from '../lib/types';

  let { api, router }: { api: ApiClient; router: Router } = $props();
  let customers = $state<Customer[]>([]);
  let loading = $state(true);
  let error = $state('');

  onMount(async () => {
    try { customers = (await api.customers()).items; }
    catch (reason) { error = reason instanceof Error ? reason.message : 'Customers could not be loaded.'; }
    finally { loading = false; }
  });
</script>

<section class="page-heading"><div><p class="eyebrow">Reviewed account map</p><h1>Customers</h1><p>Stable customer identities and their mapped AWS accounts.</p></div></section>
{#if error}<p class="inline-error" role="alert">{error}</p>{/if}
{#if loading}<Loading />{:else}<div class="customer-directory">{#each customers as customer}<button onclick={() => router.navigate(`/customers/${customer.id}`)}><span><strong>{customer.name}</strong><small>{customer.id}</small></span><span>{customer.accounts.length} {customer.accounts.length === 1 ? 'account' : 'accounts'} <b aria-hidden="true">→</b></span></button>{/each}</div>{/if}
